<template>
  <div style="font-size:16px;width:100%;background:#eff1f5"
       class="iconTable_content"
       ref="iconTable_content">
    <!-- <div class="iconTable"
         :class="{'hiddenIconTable':iconTableStatus}">
      <div class="list"
           v-for="(item,index) in getAllIconTables"
           :key="index"
           @click="iconcheck(index,item.type,item.imgid,item.meta)">
        <svg class="icon"
             aria-hidden="true"
             style="color:#75819a">
          <use ref="iconitem"
               :href="'#'+item.imgid"
               v-bind:class="{'active':pathNow() === item.type}"></use>
        </svg>
        <div class="listname"
             :class="{'on':pathNow() === item.type}">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div> -->
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'MonitoringCenter',
  data () {
    return {
      iconid: '',
      choosed: 0,
      activeComponent: 'RealTimeRain',
      iconTableStatus: false,
      posY: ''
    }
  },
  computed: {
    getAllIconTables: {
      get () {
        return this.$store.state.allIconTables
      },
      set () {
        this.$store.dispatch('setSubMenu', '监测中心')
      }
    }
  },
  methods: {
    iconcheck: function (index, type, theid, name) {
      this.$router.push({ name: type })
      this.choosed = index
      this.activeComponent = type
    },
    pathNow () {
      return this.$route.name
    }
  },
  created () {
    this.$store.dispatch('setSubMenu', '监测中心')
  },
  mounted () {
    document.body.onmousemove = e => {
      this.posY = e.clientY
      if (this.posY > 140) {
        this.iconTableStatus = true
      } else if (this.posY < 70) {
        this.iconTableStatus = false
      }
    }
    let topDiv = document.getElementsByClassName('top')
    this.$refs['iconTable_content'].style.height = (document.documentElement.clientHeight - topDiv[0].offsetHeight) + 'px'
  }
}
</script>
<style scoped>
.active {
  color: #3d71fb;
}
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.iconTable {
  width: 100%;
  height: 80px;
  z-index: 998;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  position: relative;
  animation: slowSHow 0.5s ease;
}
.hiddenIconTable {
  top: -80px;
  animation: slowHidden 0.5s ease;
}
@keyframes slowHidden {
  0% {
    top: 0;
  }
  100% {
    top: -80px;
  }
}
@keyframes slowSHow {
  0% {
    top: -80px;
  }
  100% {
    top: 0;
  }
}
.iconList {
  height: 100%;
  width: 100%;
  float: left;
}
.list {
  width: 100px;
  height: 100%;
  float: left;
  text-align: center;
  padding-top: 13px;
  cursor: pointer;
  margin-left: 10px;
}
.list:hover svg use,
.list:hover .listname {
  color: #3d6ffb;
}
.icon {
  width: 26px;
  height: 26px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* margin-left: 38px; */
}
.listname {
  width: 100%;
  margin-top: 5px;
  color: #666666;
  font-size: 15px;
}
/* 灰色 */
#ssyq {
  background-image: url(../../assets/monitorimg/icontab/ssyq.png);
}
#yqtj {
  background-image: url(../../assets/monitorimg/icontab/yqtj.png);
  width: 24px;
}
#syqtj {
  background-image: url(../../assets/monitorimg/icontab/yqtj.png);
  width: 24px;
}
#sssq {
  background-image: url(../../assets/monitorimg/icontab/sssq.png);
}
#sksq {
  background-image: url(../../assets/monitorimg/icontab/sksq.png);
}
#tqyb {
  background-image: url(../../assets/monitorimg/icontab/tqyb.png);
  width: 36px;
}
#tflj {
  background-image: url(../../assets/monitorimg/icontab/tflj.png);
}
#wxyt {
  background-image: url(../../assets/monitorimg/icontab/wxyt.png);
}
#ldt {
  background-image: url(../../assets/monitorimg/icontab/ldt.png);
}
#dlyb {
  background-image: url(../../assets/monitorimg/icontab/dlyb.png);
}
#spjk {
  background-image: url(../../assets/monitorimg/icontab/spjk.png);
  width: 34px;
}
/* 高亮 */
#ssyq1 {
  background-image: url(../../assets/monitorimg/icontab/ssyq1.png);
}
#yqtj1 {
  background-image: url(../../assets/monitorimg/icontab/yqtj1.png);
  width: 24px;
}
#syqtj1 {
  background-image: url(../../assets/monitorimg/icontab/yqtj1.png);
  width: 24px;
}
#sssq1 {
  background-image: url(../../assets/monitorimg/icontab/sssq1.png);
}
#sksq1 {
  background-image: url(../../assets/monitorimg/icontab/sksq1.png);
}
#tqyb1 {
  background-image: url(../../assets/monitorimg/icontab/tqyb1.png);
  width: 36px;
}
#tflj1 {
  background-image: url(../../assets/monitorimg/icontab/tflj1.png);
}
#wxyt1 {
  background-image: url(../../assets/monitorimg/icontab/wxyt1.png);
}
#ldt1 {
  background-image: url(../../assets/monitorimg/icontab/ldt1.png);
}
#dlyb1 {
  background-image: url(../../assets/monitorimg/icontab/dlyb1.png);
}
#spjk1 {
  background-image: url(../../assets/monitorimg/icontab/spjk1.png);
  width: 34px;
}
.on {
  color: #3d6ffb;
}
</style>
